import axios from 'axios';
import configData from '../config.json';
import Cookies from 'js-cookie';

// const source = axios.CancelToken.source();
let accessToken = Cookies.get('accessToken');
const instance = axios.create({
    // baseURL: configData.API_URL,
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
});

instance.CancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;

instance.interceptors.request.use(function (config) {
    // Do something before request is sent
    // solution for: axios config is being loaded at the time of storing the token, so it was accessing it before it is stored
    const token = Cookies.get('accessToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  }, function (error) {

    if (error.response.status === 401) {
        if (error.response.data.message && error.response.data.message === 'Unauthenticated.') {
            console.log('invalid token!');

            // check if token has expired, then refresh token

            // refresh token..
            // instance.get(`/auth/authUser`)
            // .then(res => {
            //     console.log(res);
            // })
            // .catch(err => {
            //     console.log(err);
            // });
        }
    }

    // console.log(error.response.status);

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  });

// instance.interceptors.response.use((response) => {

//     if(response.status === 401) {
//         alert("You are not authorized");
//     }

//     return response;
// }, (error) => {

//     console.log('error eh hehe');
//     if (error.response && error.response.data) {
//         return Promise.reject(error.response.data);
//     }

//     if(error.response.status === 401) {
//         alert("You are not authorized");
//     }

//     return Promise.reject(error.message);
// });

// instance.interceptors.response.use(response => response, error => {
//     if(error.response.status === 402) alert('error!');
//     return error;
// });

// instance.interceptors.response.use(
//     (response) => 
//         new Promise((resolve, reject) => {
//             resolve(response)
//         }),
//     (error) => {
//         if (!error.response) {
//             return new Promise((resolve, reject) => {
//                 reject(error);
//             });
//         }

//         // if (error.response.status === 401) {
//         //     window.location = "/logout";
//         // }
//     }
// );

// instance.interceptors.response.use(function (response) {
//     return response;
// }, function (error) {
// });

//     const { status, data, config } = error.response;

//     let urlSegment = window.location.pathname.split( '/' );
//     let lastSegment = urlSegment.pop();

//     if (status == 401 && lastSegment !== 'login') {
//         // alert('egul!');
//         // return history.push('/logout');
//     }
// });

export default instance;